<template>
  <div class="group-wrap">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree
          :data="viewTreeData"
          @getTreeData="getTreeData"
          @tabTreeDefault="tabTreeDefault"
          @tabTreeClick="tabTreeClick"
          @changeCompany="changeCompany"
        ></tab-tree>
      </div>
      <div class="content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="search-box box">
          <time-search
            ref="timeSearch"
            :control="{ data: timeData }"
            @timeControlChange="timeControlChange"
            @timeControlClick="TimeControlClick"
          ></time-search>
        </div>
        <div class="chart-content">
          <el-row :gutter="14" style="height: 100%">
            <el-col :span="24" style="height: 100%">
              <div class="chart-box">
                <div class="title">成本趋势图</div>
                <div class="chart" id="lineChart"></div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="chart-box table-content">
          <nk-table
            :border="true"
            :columns="columns"
            :data="tableData"
          ></nk-table>
        </div>
      </div>
    </resize-container>
  </div>
</template>

<script>
import TabTree from "@/components/common/TabTree.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import api from "@common/api/index.js";
import { findDataByParam } from "@/utils/index.js";
import handleData from "@/utils/handleData.js";
import NkTable from "@/components/common/NkTable.vue";
import echarts from "echarts";
import ResizeContainer from "@/components/common/resizeContainer.vue";
import dateTool from "@/utils/dateTool";
let eleTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
export default {
  components: { TabTree, BtnShow, TimeSearch, NkTable, ResizeContainer },
  data() {
    return {
      tabShow: true,
      viewTreeData: [],
      viewNodeData: [],
      timeData: eleTimeData,
      selectedMeasure: {
        id: "",
        measureName: "",
      },
      selectedDate: {
        startTime: "",
        endTime: "",
      },
      columns: [
        { prop: "thisTime", label: "本期时间", show: true },
        { prop: "thisValue", label: "本期成本", show: true },
        { prop: "oldTime", label: "环期时间", show: true },
        { prop: "oldValue", label: "环期成本", show: true },
        { prop: "differ", label: "增减量", show: true },
        {
          prop: "differScale",
          label: "趋势",
          show: true,
        },
      ],
      lineCharts: null,
      pieCharts: null,
      tableData: [],
      point: null,
    };
  },
  created() {},
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted() {
    let vm = this;
    vm.drawLine();
  },
  methods: {
    changeCompany(companyId) {
      let vm = this;
      api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(companyId, "/cost/costRing", null)
        .then((res) => {
          const viewTreeData = findDataByParam("viewTree", true, res.data);
          // const point = findDataByParam("point", true, res.data);
          const point = {
            pointCode: "100229",
            pointNumber: "0",
            energyType: "1",
          };
          vm.point = point;
          vm.viewTreeData = viewTreeData;
        });
    },
    timeControlChange(e) {
      this.selectedDate = e;
    },
    TimeControlClick(e) {
      let vm = this;
      vm.selectedDate = e;
      vm.getData();
    },
    getTreeData(data) {
      let vm = this;
      vm.viewNodeData = data;
    },
    tabTreeDefault(e) {
      let vm = this;
      vm.selectedMeasure = e;
      vm.getData();
    },
    tabTreeClick(e) {
      let vm = this;
      vm.selectedMeasure = e;
      vm.getData();
    },
    getData() {
      let vm = this;
      let startTime = vm.selectedDate.startTime;
      let endTime = vm.selectedDate.endTime;
      let dateType = vm.selectedDate.dateType;

      //环期时间
      let startTimeSame = null;
      let endTimeSame = null;
      let xData = [];
      let xDataSame = [];
      let apiName = "";
      let apiName2 = "";
      let isDayOrWeek = false;
      let isMonth = false;
      if (dateType == "day") {
        startTimeSame = dateTool.format(
          new Date(
            new Date(startTime).setDate(new Date(startTime).getDate() - 1)
          ),
          "yyyy-MM-dd hh:mm:sss"
        );
        endTimeSame = startTime;
        xData = handleData.createXData("0", startTime, endTime, false);
        xDataSame = handleData.createXData(
          "0",
          startTimeSame,
          endTimeSame,
          false
        );
        apiName = "getSpentMoneyHour";
        apiName2 = "getSpentMoneyHour";
      } else if (dateType == "month") {
        isMonth = true;
        isDayOrWeek = true;
        startTimeSame = dateTool.format(
          new Date(
            new Date(startTime).setMonth(new Date(startTime).getMonth() - 1)
          ),
          "yyyy-MM-dd hh:mm:sss"
        );
        endTimeSame = startTime;
        xData = handleData.createXData("2", startTime, endTime, false);
        xDataSame = handleData.createXData(
          "2",
          startTimeSame,
          endTimeSame,
          false
        );
        apiName = "getSpentMoneyDay";
        apiName2 = "getSpentMoneyDay";
      } else {
        startTimeSame = dateTool.format(
          new Date(
            new Date(startTime).setFullYear(
              new Date(startTime).getFullYear() - 1
            )
          ),
          "yyyy-MM-dd hh:mm:sss"
        );
        endTimeSame = startTime;
        xData = handleData.createXData("5", startTime, endTime, false);
        xDataSame = handleData.createXData(
          "5",
          startTimeSame,
          endTimeSame,
          false
        );
        apiName = "getSpentMoneyMonth";
        apiName2 = "getSpentMoneyMonth";
      }

      let apiList = [];

      if (isDayOrWeek) {
        apiList = [
          api.cost[apiName](
            vm.selectedMeasure.measureId,
            startTime,
            endTime,
            vm.point.pointCode,
            vm.point.pointNumber,
            vm.point.energyType,
            null,
            null
          ),
          api.cost[apiName2](
            vm.selectedMeasure.measureId,
            startTimeSame,
            endTimeSame,
            vm.point.pointCode,
            vm.point.pointNumber,
            vm.point.energyType,
            null,
            null
          ),
        ];
      } else {
        apiList = [
          api.cost[apiName](
            vm.selectedMeasure.measureId,
            startTime,
            endTime,
            vm.point.pointCode,
            vm.point.pointNumber,
            vm.point.energyType,
            null
          ),
          api.cost[apiName2](
            vm.selectedMeasure.measureId,
            startTimeSame,
            endTimeSame,
            vm.point.pointCode,
            vm.point.pointNumber,
            vm.point.energyType,
            null
          ),
        ];
      }
      const dateObj = {
        day: "Hour",
        week: "Day",
        month: "Day",
        year: "Month",
      };

      apiList.push(
        api.cost[`getSpentMoney${dateObj[dateType]}`](
          vm.selectedMeasure.measureId,
          startTime,
          endTime,
          vm.point.pointCode,
          vm.point.pointNumber,
          vm.point.energyType,
          null
        ),
        api.cost[`getSpentMoney${dateObj[dateType]}`](
          vm.selectedMeasure.measureId,
          startTimeSame,
          endTimeSame,
          vm.point.pointCode,
          vm.point.pointNumber,
          vm.point.energyType,
          null
        )
      );

      Promise.all(apiList).then((resArr) => {
        vm.setLine([resArr[0], resArr[1]], xData, xDataSame, isMonth);

        //设置表格信息
        let tableData = [];
        let thisValue =
          typeof resArr[2].data.value == "number"
            ? resArr[2].data.value.toFixed(2)
            : "-";
        let oldValue =
          typeof resArr[3].data.value == "number"
            ? resArr[3].data.value.toFixed(2)
            : "-";
        let differ = "-";
        let differScale = "-";

        if (thisValue !== "-" && oldValue !== "-") {
          if (oldValue == "0.00") {
            differ = "0.00";
            differScale = "0.00";
          } else {
            differ = (parseFloat(thisValue) - parseFloat(oldValue)).toFixed(2);
            differScale = (
              (parseFloat(differ) / parseFloat(oldValue)) *
              100
            ).toFixed(2);
          }
        }
        let date = null;
        let oldDate = null;
        if (vm.selectedDate.dateType == "day") {
          date = startTime.substring(0, 11);
          oldDate = startTimeSame.substring(0, 11);
        } else if (vm.selectedDate.dateType == "month") {
          date = startTime.substring(0, 7);
          oldDate = startTimeSame.substring(0, 7);
        } else {
          date = startTime.substring(0, 4) + "年";
          oldDate = startTimeSame.substring(0, 4) + "年";
        }
        tableData.push({
          thisTime: date,
          thisValue: thisValue,
          oldTime: oldDate,
          oldValue: oldValue,
          differ: differ,
          differScale: differScale + "%",
        });

        vm.tableData = tableData;
      });
    },
    setLine(resData, xData, xDataSame, isMonth) {
      let yData = [];
      let xAxisData = [];
      for (let i = 0; i < xData.length; i++) {
        xAxisData.push(xData[i].title);
        let apiData = isMonth ? resData[0].data[0] : resData[0].data;
        const item = apiData.find((c) => {
          return new Date(c.time).getTime() == xData[i].value;
        });
        yData.push(
          item && item.value && item.value !== 0 ? item.value.toFixed(2) : "-"
        );
      }
      let yDataSame = [];
      for (let i = 0; i < xDataSame.length; i++) {
        let apiData2 = isMonth ? resData[1].data[0] : resData[1].data;
        const item = apiData2.find(
          (c) => new Date(c.time).getTime() == xDataSame[i].value
        );
        yDataSame.push(
          item && item.value && item.value !== 0 ? item.value.toFixed(2) : "-"
        );
      }

      this.lineCharts.setOption({
        legend: {
          data: ["本期", "环期"],
        },
        xAxis: {
          type: "category",
          data: xAxisData,
        },
        series: [
          {
            name: "本期",
            data: yData,
            type: "line",
          },
          {
            name: "环期",
            data: yDataSame,
            type: "line",
          },
        ],
      });
    },
    drawLine() {
      let vm = this;
      this.lineCharts = echarts.init(document.getElementById("lineChart"));
      let option = {
        legend: {
          textStyle: {
            color: "#bcbdbe",
          },
        },
        xAxis: {
          type: "time",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#bcbdbe",
              width: 2,
            },
          },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: "#bcbdbe",
            },
          },
        },
        grid: {
          x: 60,
          y: 30,
          x2: 60,
          y2: 30,
          containLabel: true,
        },
        yAxis: {
          name: "元",
          type: "value",
          scale: true,
        },
        label: {},
        tooltip: {
          trigger: "axis",
          color: "#bcbdbe",
          confine: true,
          textStyle: {
            align: "left",
          },
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //     magicType: {
        //       type: ["line", "bar"],
        //     }, //切换为折线图，切换为柱状图
        //   },
        //   right: "40",
        // },
        color: [
          "#d68818",
          "#88a80a",
          "#308145",
          "#318e96",
          "#326293",
          "#3d66c1",
          "#3a32ab",
          "#6325aa",
          "#9a1eac",
          "#b92626",
        ],
        series: [],
      };
      this.lineCharts.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-wrap {
  padding: 14px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  box-sizing: border-box;
}
.tree-content {
  height: 100%;
  min-width: 200px;
  margin-right: 14px;
}
.content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  background: transparent;
  display: flex;
  flex-flow: column;
}
.search-box {
  height: 40px;
}
.chart-content {
  margin-top: 14px;
  width: 100%;
  flex: 1;
}
.chart-box {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background: #ffffff;
  flex-flow: column;
  .title {
    height: 30px;
    line-height: 30px;
    padding: 0px 10px;
    color: #000;
    text-align: left;
    font-weight: bold;
  }
  .chart {
    width: 100%;
    height: calc(100% - 30px);
    padding: 10px;
    box-sizing: border-box;
  }
}
.table-content {
  margin-top: 14px;
  height: 200px;
}
.same-item {
  padding: 10px;
  padding-bottom: 0px;
}
</style>
